import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface authType {
    accessToken: string;
    refreshToken: string;
}
const initialState: authType = {
    accessToken: "",
    refreshToken: ""
}

const tokenSlice = createSlice({
    name: "token",
    initialState,
    reducers: {
        handleAddToken:(state,action:PayloadAction<authType>)=>{
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
        }
    }
})

export const { handleAddToken } = tokenSlice.actions
export default tokenSlice.reducer